import React from 'react';
import AlertsFeed from '../components/AlertsFeed';

const AlertsPage = () => (
  <div className="p-6 md:p-8 space-y-6 max-w-[1200px] mx-auto">
    <div>
      <div className="text-xs uppercase tracking-wider text-muted-foreground font-semibold">Alerts</div>
      <h1 className="text-3xl font-bold text-brand-indigo">RM Coaching Feed</h1>
      <p className="text-sm text-muted-foreground mt-1">Score dips, overdue follow-ups and missing signed reports across your team.</p>
    </div>
    <AlertsFeed />
  </div>
);

export default AlertsPage;
